import {getBearer} from "../functions/getBearer";
import axios from "axios";
import {getApiLink} from "../functions/getApiLink";
import {setTimesheet} from "../storage/toolkit";
import { GetAccessToken } from "./GetAccessToken";
import getCookies from "../functions/getCookie";
import { access_token } from "./CookieKeys";

export const SetTimesheet = (dispatch: any, year?: number) => {
    if (!getCookies(access_token)) return;

    const date = new Date()

    getBearer("get")
    axios.get(getApiLink(`/api/timesheet/my/?year=${year && isNaN(year) ? date.getFullYear() : !year ? date.getFullYear() : year}`)).then(({data}) => {
        dispatch(setTimesheet(data))
    }).catch(er => {
        er?.response?.status === 401 && GetAccessToken(dispatch, () => SetTimesheet(dispatch, year))
    })
}